import { createFileRoute } from '@tanstack/react-router'
import SlidesAdmPage from '@/spa/pages/SlidesAdmPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/slides/adm')({
  component: SlidesAdmPage,
  errorComponent: routeErrorComponent,
})
